import axios from 'axios';
import { useSnackbar } from 'notistack';
import React from 'react';
import { useState } from 'react';
import { createContext } from 'react';
import { useContext } from 'react';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { ERROR_MESSAGES } from '../../configs/messages';
import showMessage from '../../helpers/showMessage';
import { LOCAL_STORAGE_USER, SESSION_NAME } from '../../configs/constants';
import { jwtDecode } from 'jwt-decode';

const authContext = createContext();

function useProvideAuth() {
    const [isLogged, setIsLogged] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const requestUrl = process.env.REACT_APP_CMS_API_PATH;

    const saveUserData = (user) => {
        const userStr = JSON.stringify(user);
        localStorage.setItem(LOCAL_STORAGE_USER, userStr);
        setIsLogged(true);
    }

    const clearUserData = () => {
        localStorage.removeItem(LOCAL_STORAGE_USER);
        setIsLogged(false);
        // clearCookie(SESSION_NAME, {path: '/', domain: process.env.REACT_APP_PUBLIC_PATH.replace(/(https?:\/\/|)/) })
    }

    const getUserData = () => {
        const storageUser = localStorage.getItem(LOCAL_STORAGE_USER);
        if (storageUser) {
            return JSON.parse(storageUser);
        }
        return {}
    }

    const checkUserIsLogged = () => {
        const user = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER));
        if (user) {
            const token = user.accessToken;
            if (!isTokenExpired(token)) {
                return true;
            }
            clearUserData();
            return false;
        }
        return false;
    }

    const isTokenExpired = (token) => {
        try {
            const decodedToken = jwtDecode(token);
            if (decodedToken.exp * 1000 < Date.now()) {
                return true;
            }
            return false;
        } catch (error) {
            console.error('Invalid token:', error);
            return true;
        }
    }

    const logIn = (email, password) => {
        return axios({
            url: requestUrl + '/auth/login',
            method: 'POST',
            data: { email, password },
            withCredentials: true,
        })
            .then((response) => {
                saveUserData(response.data?.data);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    const logOut = () => {
        return axios({
            url: requestUrl + '/auth/logout',
            method: 'POST',
            withCredentials: true,
        })
            .then(() => {
                return clearUserData();
            })
            .then(() => {})
            .catch((error) => console.error(error));
    };

    // const passwordReset = (email) => {
    //     return axios({
    //         method: 'POST',
    //         data: { email },
    //         withCredentials: true,
    //     })
    //         .then(() => {
    //             return true;
    //         })
    //         .catch((error) => console.error(error));
    // };

    // const confirmPasswordReset = (password, confirmPassword) => {
    //     return axios({
    //         method: 'POST',
    //         data: { password, confirmPassword },
    //     })
    //         .then(() => {
    //             return true;
    //         })
    //         .catch((error) => console.error(error));
    // };

    // useEffect(() => {
    //     if (cookies[SESSION_NAME]) {
    //         axios({
    //             url: requestUrl + '/auth/check-user',
    //             withCredentials: true,
    //         })
    //             .then((response) => {
    //                 if (!isLogged) {
    //                     setIsLogged(true);
    //                 }
    //                 saveUserData(response.data?.data);
    //             })
    //             .catch((error) => {
    //                 console.error(error);
    //                 // return clearUserData();
    //             })
    //             .finally(() => {})
    //     } 
    //     // else {
    //     //     clearUserData()
    //     // }
    // });

    return {
        isLogged,
        getUserData,
        checkUserIsLogged,
        logIn,
        logOut,
        // passwordReset,
        // confirmPasswordReset,
    };
}

export function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export const useAuth = () => {
    return useContext(authContext);
};